import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import Desafio from "@/pages/admin/Desafio";
import { pageHead } from "@/lib/seo";

const busca = z.object({
  aba: z.enum(["andamento", "registros", "participantes", "configurar"]).optional().catch(undefined),
  /** Registros de um dia (AAAA-MM-DD). */
  dia: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
  /** Registros, placar e metas de uma participante (o id dela no desafio, nunca o e-mail). */
  participante: z.string().max(80).optional().catch(undefined),
});

export const Route = createFileRoute("/admin/desafios/$id")({
  validateSearch: busca,
  head: () => pageHead({ title: "Desafio | Painel", path: "/admin/desafios", noindex: true }),
  component: Desafio,
});
